import styled from '@emotion/styled';

export const AvailabilityPrompt = styled.p`
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 20px;
`;
